import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Empty, Icon, message, Spin
} from 'antd';
import REDUCER_KEY from 'reducers/reducer.keys';
import {
  add, init, list, reset
} from 'actions';
import { RosterVersion } from 'components/Timeline';
import config from './config';
import NotificationInput from './input';

/**
 * @description Prepare data for api
 * @param props Object object_id, collection, tag_value, start_date, expiry_date, theme
 * @return data object
 */
const handlePrepareData = ({
  type, delta, is_before, context_theme_id, context_object_id, rosterVersion
}) => ({
  type_id: type.key,
  type: {
    id: type.key,
    name: type.label
  },
  delta: delta || '0 00:00:00',
  is_before: is_before || false,
  context_theme_id,
  context_object_id,
  version_id: rosterVersion
});

/**
 * @description Map data and server flight
 * @param {state} Object
 */
const mapStateToProps = (state, props) => ({
  themes: state.api.notificationTheme.data.results,
  inFlight: state.api.notificationTheme.inFlight,
  item: state.api[props.reducer.key].data,
  formInFlight: state.api[props.reducer.key].inFlight,
  formError: state.api[props.reducer.key].error
});

const mapDispatchToProps = (dispatch, props) => ({
  loadTheme() {
    const page = 0;
    const pageSize = 1;
    const filters = [{
      id: 'model',
      value: props.themeName
    }];
    const sorted = [{
      id: 'model',
      desc: false
    }];

    return dispatch(list(
      REDUCER_KEY.notificationTheme.key, {
        page,
        pageSize,
        filters,
        sorted
      }
    ));
  },
  create() {
    dispatch(init(props.reducer.key, { is_before: true }));
  },
  saveItem(id, data) {
    return dispatch(add(props.reducer.key, data));
  },
  clearTheme() {
    dispatch(reset(REDUCER_KEY.notificationTheme.key));
  }
});

const BulkNotifications = ({
  create, inFlight, item, clearTheme, loadTheme, objects, saveItem, themes, onSave, onCancel
}) => {
  const handleSaveClick = (id, data) => {
    const preparedData = handlePrepareData({
      ...data,
      context_object_id: objects,
      context_theme_id: themes.length ? themes[0].id : -1
    });
    return saveItem(id, preparedData)
      .then((response) => {
        message.success('Notification added successfully');
        create(); // reset form to default
        onSave(response, preparedData); // callback
        return response;
      },
      (error) => {
        message.error('Notification save failed');
        return error;
      });
  };
  useEffect(() => {
    loadTheme();
    return () => {
      clearTheme();
    };
  }, []);
  if (!themes.length) {
    return (
      <div className="bhp-container">
        <Spin indicator={<Icon type="loading" spin />} tip="Loading..." spinning={inFlight}>
          <Empty
            image="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxKSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxlbGxpcHNlIGZpbGw9IiNGNUY1RjUiIGN4PSIzMiIgY3k9IjMzIiByeD0iMzIiIHJ5PSI3Ii8+CiAgICA8ZyBmaWxsLXJ1bGU9Im5vbnplcm8iIHN0cm9rZT0iI0Q5RDlEOSI+CiAgICAgIDxwYXRoIGQ9Ik01NSAxMi43Nkw0NC44NTQgMS4yNThDNDQuMzY3LjQ3NCA0My42NTYgMCA0Mi45MDcgMEgyMS4wOTNjLS43NDkgMC0xLjQ2LjQ3NC0xLjk0NyAxLjI1N0w5IDEyLjc2MVYyMmg0NnYtOS4yNHoiLz4KICAgICAgPHBhdGggZD0iTTQxLjYxMyAxNS45MzFjMC0xLjYwNS45OTQtMi45MyAyLjIyNy0yLjkzMUg1NXYxOC4xMzdDNTUgMzMuMjYgNTMuNjggMzUgNTIuMDUgMzVoLTQwLjFDMTAuMzIgMzUgOSAzMy4yNTkgOSAzMS4xMzdWMTNoMTEuMTZjMS4yMzMgMCAyLjIyNyAxLjMyMyAyLjIyNyAyLjkyOHYuMDIyYzAgMS42MDUgMS4wMDUgMi45MDEgMi4yMzcgMi45MDFoMTQuNzUyYzEuMjMyIDAgMi4yMzctMS4zMDggMi4yMzctMi45MTN2LS4wMDd6IiBmaWxsPSIjRkFGQUZBIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
            description="Please select a record"
          />
        </Spin>
      </div>
    );
  }
  return (
    <RosterVersion.Consumer>
      {({ rosterVersion }) => (
        <NotificationInput
          canAdmin
          title="Notification"
          onSaveClick={(id, data) => handleSaveClick(id, {
            ...data,
            rosterVersion
          })}
          onCancelClick={onCancel}
          dataSource={{
            ...config.init,
            ...item
          }}
        />
      )}
    </RosterVersion.Consumer>
  );
};

BulkNotifications.propTypes = {
  create: PropTypes.func,
  inFlight: PropTypes.bool,
  loadTheme: PropTypes.func,
  item: PropTypes.object,
  objects: PropTypes.array,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  themes: PropTypes.array,
  saveItem: PropTypes.func,
  clearTheme: PropTypes.func
};

BulkNotifications.defaultProps = {
  create() {
  },
  inFlight: false,
  loadTheme() {
  },
  item: {},
  objects: [],
  themes: [],
  onSave() {
  },
  onCancel() {
  },
  saveItem() {
  },
  clearTheme() {
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkNotifications);
